import React, { createContext, useReducer } from 'react';

/**
 * Context that stores load settings for OData requests
 */
export const LoadSettingsContext = /*#__PURE__*/createContext({
  setLoadSettings: () => undefined,
  setLoadChildrenSettings: () => undefined,
  setLoadAncestorsSettings: () => undefined,
  loadAncestorsSettings: {},
  loadChildrenSettings: {},
  loadSettings: {}
});
LoadSettingsContext.displayName = 'LoadSettingsContext';
const initialLoadChildrenSettings = {
  orderby: [['DisplayName', 'asc']],
  select: 'all',
  expand: ['CreatedBy']
};
/**
 * Provider for the LoadSettingsContext. Sets up default loading settings.
 */

const setLoadSettingsReducer = (state, value) => {
  if (JSON.stringify(value) === JSON.stringify(state)) {
    return state;
  }

  return value;
};

const setLoadChildrenSettingsReducer = (state, value) => {
  if (JSON.stringify(value) === JSON.stringify(state)) {
    return state;
  }

  return value;
};

export const LoadSettingsContextProvider = props => {
  var _props$loadChildrenSe;

  const [loadSettings, setLoadSettings] = useReducer(setLoadSettingsReducer, {});
  const [loadChildrenSettings, setLoadChildrenSettings] = useReducer(setLoadChildrenSettingsReducer, (_props$loadChildrenSe = props.loadChildrenSettings) !== null && _props$loadChildrenSe !== void 0 ? _props$loadChildrenSe : initialLoadChildrenSettings);
  const [loadAncestorsSettings, setLoadAncestorsSettings] = useReducer(setLoadSettingsReducer, {});
  return /*#__PURE__*/React.createElement(LoadSettingsContext.Provider, {
    value: {
      loadSettings,
      loadChildrenSettings,
      loadAncestorsSettings,
      setLoadSettings,
      setLoadChildrenSettings,
      setLoadAncestorsSettings
    }
  }, props.children);
};
//# sourceMappingURL=load-settings.js.map